var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuscarActivo24X24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3.74995C6.99594 3.74995 3.75 6.99589 3.75 11C3.75 15.004 6.99594 18.25 11 18.25C15.0041 18.25 18.25 15.004 18.25 11C18.25 6.99589 15.0041 3.74995 11 3.74995ZM2.25 11C2.25 6.16746 6.16751 2.24995 11 2.24995C15.8325 2.24995 19.75 6.16746 19.75 11C19.75 15.8324 15.8325 19.75 11 19.75C6.16751 19.75 2.25 15.8324 2.25 11Z",
    fill: "CurrentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9697 16.4276C16.2626 16.1347 16.7374 16.1347 17.0303 16.4276L22.0303 21.4276C22.3232 21.7205 22.3232 22.1954 22.0303 22.4883C21.7374 22.7812 21.2626 22.7812 20.9697 22.4883L15.9697 17.4882C15.6768 17.1953 15.6768 16.7205 15.9697 16.4276Z",
    fill: "CurrentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuscarActivo24X24);
export default __webpack_public_path__ + "static/media/BUSCAR_ACTIVO_24X24.a34e39b21d5659a9a9c6e0b47f901fc3.svg";
export { ForwardRef as ReactComponent };